<template>
    <Layout is-crm class="customers-stylesheet-page" :content-class="'content--centered'">
        <Spinner v-if="loading" />
        <CustomersStylesheet :filters="params" />
    </Layout>
</template>

<script>
import { CustomersStylesheet } from '../../components';
import Layout from '@speechki-frontend/shared/ui/layout/Layout';
import Spinner from '@speechki-frontend/shared/ui/Spinner';

export default {
    name: 'CustomersStylesheetPage',
    components: {
        CustomersStylesheet,
        Layout,
        Spinner,
    },
    data() {
        return {
            loading: false,
        };
    },
    computed: {
        params() {
            const { id: customer } = this.$route.params;
            return { customer };
        },
    },
};
</script>

<style lang="scss" src="./CustomersStylesheetPage.scss"></style>
